export default __webpack_public_path__ + "static/media/github.22fac027.svg";